import { render, staticRenderFns } from "./on-time-delivery.vue?vue&type=template&id=cd2c0060&scoped=true&"
import script from "./on-time-delivery.vue?vue&type=script&lang=js&"
export * from "./on-time-delivery.vue?vue&type=script&lang=js&"
import style0 from "./on-time-delivery.vue?vue&type=style&index=0&id=cd2c0060&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2c0060",
  null
  
)

export default component.exports